// extracted by mini-css-extract-plugin
export default {"reset-password-button":"ResetPasswordButton_reset-password-button__LayuT"};